// import { createStyles, makeStyles } from "@mui/styles";

// const useStyles = makeStyles(() => {
//   return createStyles({
//     "@global": {
//       "*": {
//         boxSizing: "border-box",
//         margin: 0,
//         padding: 0,
//       },
//       html: {
//         "-webkit-font-smoothing": "antialiased",
//         "-moz-osx-font-smoothing": "grayscale",
//         height: "100%",
//         width: "100%",
//       },
//       body: {
//         backgroundColor: "#f4f6f8",
//         height: "100%",
//         width: "100%",
//       },
//       a: {
//         textDecoration: "none",
//       },
//       "#root": {
//         height: "100%",
//         width: "100%",
//       },
//     },
//   });
// });

// const GlobalStyles = () => {
//   useStyles();

//   return null;
// };

// export default GlobalStyles;

import { createStyles, makeStyles } from "@mui/styles";

const useStyles = makeStyles(() => {
  return createStyles({
    "@global": {
      "*": {
        boxSizing: "border-box",
        margin: 0,
        padding: 0,
      },
      ":root": {
        "--background": "#FFFFFF",
        "--foreground": "#004D37",
        "--card": "#FFFFFF",
        "--card-foreground": "#004D37",
        "--primary": "#DD6B17",
        "--primary-foreground": "#FFFFFF",
        "--secondary": "#EFE7DA",
        "--secondary-foreground": "#004D37",
        "--muted": "#F7F5F2",
        "--muted-foreground": "#4A7A6A",
        "--accent": "#DEF5BA",
        "--accent-foreground": "#004D37",
        "--destructive": "#DC2626",
        "--destructive-foreground": "#FFFFFF",
        "--border": "#E8E4DF",
        "--input": "#F7F5F2",
        "--ring": "#75AC38",

        "--trust-green": "#004D37",
        "--action-green": "#75AC38",
        "--light-green": "#DEF5BA",
        "--action-orange": "#DD6B17",
        "--sand": "#EFE7DA",

        "--radius": "0.5rem",
      },
      ".dark": {
        "--background": "#0A2A20",
        "--foreground": "#F5F7F6",
        "--card": "#0F3328",
        "--card-foreground": "#F5F7F6",
        "--secondary": "#1A4536",
        "--muted": "#1A4536",
        "--border": "#1F5040",
        "--input": "#1A4536",
        "--ring": "#75AC38",
      },
      html: {
        "-webkit-font-smoothing": "antialiased",
        "-moz-osx-font-smoothing": "grayscale",
        height: "100%",
        width: "100%",
      },
      body: {
        backgroundColor: "#f4f6f8",
        height: "100%",
        width: "100%",
        fontFamily:
          "Inter, system-ui, -apple-system, Segoe UI, Roboto, Arial, sans-serif",
      },
      a: {
        textDecoration: "none",
      },
      "#root": {
        height: "100%",
        width: "100%",
      },
    },
  });
});

const GlobalStyles = () => {
  useStyles();
  return null;
};

export default GlobalStyles;
